import { render, staticRenderFns } from "./Romanza_dessertWine.vue?vue&type=template&id=2fa75f05&scoped=true"
import script from "./Romanza_dessertWine.vue?vue&type=script&lang=ts"
export * from "./Romanza_dessertWine.vue?vue&type=script&lang=ts"
import style0 from "./Romanza_dessertWine.vue?vue&type=style&index=0&id=2fa75f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa75f05",
  null
  
)

export default component.exports